<template>
  <BaseSidebar @open="$emit('open')" @close="$emit('close')">
    <template v-slot:top-bar="{ showContent, activeContent }">
      <ButtonBarItem
          label="Ficha paciente"
          variant="primary"
          @click="showContent(0)"
          :is-active="activeContent === 0"
      ><IconMedicalFile width="100%" height="100%"/></ButtonBarItem>
      <ButtonBarItem
          label="Biblioteca ejercicios"
          variant="primary"
          @click="showContent(1)"
          :is-active="activeContent === 1"
      ><IconDumbbell width="100%" height="100%"/></ButtonBarItem>
    </template>

    <template v-slot:bottom-bar>
      <ButtonBarItem
        label="Agregar rutina"
        variant="secondary"
        @click="addRoutine"
      ><IconAdd width="100%" height="100%"/></ButtonBarItem>

      <div class="btnbar-separator"></div>

      <ButtonBarItem
        label="Guardar programa"
        variant="info"
        @click="saveProgram"
        :disabled="!unsavedChanges || isProcessing"
      >
        <IconSave width="100%" height="100%"/>
        <SpinnerBackdrop v-if="isSaving" size="1.5rem" thickness="0.2rem" variant="info"/>
      </ButtonBarItem>
      <ButtonBarItem
        label="Descargar programa"
        variant="info"
        @click="getProgramFile"
        :disabled="isProcessing"
      >
        <IconExport width="100%" height="100%"/>
        <SpinnerBackdrop v-if="isExporting" size="1.5rem" thickness="0.2rem" variant="info"/>
      </ButtonBarItem>
    </template>

    <template v-slot:contents>
      <PatientInfo data-content-ref="0" :program-data="programData"/>
      <ExercisesLibrary data-content-ref="1"/>
    </template>
  </BaseSidebar>
</template>

<script>
  import BaseSidebar from './base/BaseSidebar'
  import ButtonBarItem from './base/ButtonBarItem'
  import PatientInfo from './content/PatientInfo'
  import ExercisesLibrary from './content/ExercisesLibrary'
  import IconDumbbell from "../icon/IconDumbbell";
  import IconAdd from "../icon/IconAdd";
  import IconExport from "../icon/IconExport";
  import IconSave from '../icon/IconSave'
  import SpinnerBackdrop from '../SpinnerBackdrop'
  import IconMedicalFile from '../icon/IconMedicalFile'

  export default {
    name: 'ProgramSidebar',
    components: {
      IconMedicalFile,
      SpinnerBackdrop,
      IconSave,
      IconExport,
      IconAdd,
      IconDumbbell,
      ExercisesLibrary,
      PatientInfo,
      BaseSidebar,
      ButtonBarItem
    },
    props: {
      unsavedChanges: {
        type: Boolean,
        default: false,
      },
      isSaving: {
        type: Boolean,
        default: false,
      },
      isExporting: {
        type: Boolean,
        default: false,
      },
      programData: {
        type: Object,
        default: function(){
          return {};
        },
      }
    },
    computed: {
      isProcessing () { return this.isSaving || this.isExporting; }
    },
    methods: {
      getProgramFile () {
        this.$emit("get-program-file");
      },
      saveProgram () {
        this.$emit("save-program");
      },
      addRoutine () {
        this.$emit("add-routine");
      },
    },
  }
</script>

<style scoped lang="scss">
  .btnbar-separator {
    background-color: $gray-300;
    height: 1px;
    margin: $spacer auto;
    width: $btnbar-btn-size*0.8;
  }
</style>